module.exports = __webpack_public_path__ + "static/media/right-sidebar-header.42565a8d.svg";